import React, { useState } from 'react'
import { jsPDF } from "jspdf";
import 'jspdf-autotable'
import { faker } from '@faker-js/faker';
import { useSelector } from 'react-redux';

const PdfDownload = ({ check_inclusive, total, title,date }) => {
  const headerFooter = useSelector((state) => state?.ModalReducer?.lotIntent);
  const [imgUrl, setImgUrl] = useState()
  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }

  getBase64FromUrl(headerFooter?.company_logo).then((data) => {
    setImgUrl(data);
  })

  const PrintDocument = () => {
    var doc = new jsPDF('p', 'mm', 'a4');
    var pageSize = doc.internal.pageSize
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var text = doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {})
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10)
    doc.text(`DATE: ${date}`, 150, 42);
    doc.setLineWidth(0.2);
    doc.line(150, 43, 179, 43)
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14)
    doc.text("Letter of Intent", pageWidth / 2.5, 49);
    doc.setLineWidth(0.4);
    doc.line(pageWidth / 2.5, 50, pageWidth / 1.77, 50)
    if (!check_inclusive)
      doc.autoTable({
        html: '#my-table1',
        startY: 60,
        theme: 'grid',
        tableWidth: 'nowrap',
        styles: { cellPadding: 1, fontSize: 12 },
        bodyStyles: { textColor: [0, 0, 0] }
      })
    else {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11)
      doc.text(`The Total Amount with All Inclusive is ${total} Rs.`, pageWidth / 12, 65);
    }
    doc.autoTable({
      html: '#my-table', theme: 'grid', startY: 80, tableWidth: 'nowrap',
      styles: { cellPadding: 1, fontSize: 12, overflow: "linebreak", textColor: [0, 0, 0] },
      columnStyles: { 1: { fontStyle: 'bold', minCellWidth: 50, cellPadding: { top: 1, right: 2, bottom: 1, left: 2 } } },
      showHead: "everyPage",
      margin: { vertical: 45 },
      didDrawPage: function (data) {
        // Header
        doc.addImage(imgUrl, 'JPEG', data.settings.margin.left, 10, 50, 30);
        doc.setTextColor(40);
        doc.setFont('times', 'bold');
        doc.setFontSize(14)
        console.log("asasa", headerFooter?.name_of_company)
        doc.text(headerFooter?.name_of_company, data.settings.margin.left + 100, 20);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9)
        doc.text(headerFooter?.company_address, data.settings.margin.left + 100, 25, {
          maxWidth: 60
        })
        doc.text(`Tel.: ${headerFooter?.contact_number} Fax: ${headerFooter?.fax_number}`, data.settings.margin.left + 100, 37, {
          maxWidth: 80
        })
        // Footer

        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.autoTable({
          body: [{
            title: "Site Address: ",
            content: `${headerFooter?.register_address} \nTel.: ${headerFooter?.contact_number} Fax: ${headerFooter?.fax_number}`,
          }],
          styles: { cellPadding: 1, fontSize: 8, overflow: "linebreak" },
          columnStyles: { 0: { fontStyle: 'bold', fontSize: 9 } },
          startY: pageHeight - 32,
          theme: 'plain',
        })
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7)
        doc.text(`Website: ${headerFooter?.website_url}`, pageWidth / 2.5, pageHeight - 10);
      }
    })
    window.open(doc.output('bloburl'));
  };


  return (
    <>
      <button className="border-radius-7 p-3 d-flex align-items-center buttons btn btn-secondary" onClick={PrintDocument}><span className="fs-4 d-flex gap-3 title-font-600 px-3">{title ? title : "Download"}</span></button>
    </>
  )
}

export default PdfDownload